import {axios} from '../../../lib'

export const getLastSPVCrawls = () => {
    return axios.get('/stats/crawl-logs/last')
}